import { useEffect, useState } from "react"
import { useContext } from "react"
import { CartContext } from "../context/CartContext"

import { Swiper, SwiperSlide } from "swiper/react"
import { Navigation, Autoplay } from "swiper/modules"

import "swiper/css"
import "swiper/css/navigation"

function RecommendedProducts(){

const { cart, addToCart } = useContext(CartContext)
const [products,setProducts] = useState([])

useEffect(()=>{

if(cart.length === 0) return

const category = cart[0].categories?.[0]?.slug

fetch(`/wp-json/wc/store/products?category=${category}&per_page=10`)
.then(res=>res.json())
.then(data=>setProducts(data))

},[cart])

if(products.length === 0) return null

return(

<div className="recommendedSection">

<h2>Customers also bought</h2>

<Swiper
modules={[Navigation, Autoplay]}
navigation
loop={true}
spaceBetween={20}
slidesPerView={3}
autoplay={{
delay:2500,
disableOnInteraction:false
}}
breakpoints={{
  320:{slidesPerView:1},
  768:{slidesPerView:2},
  1024:{slidesPerView:3}
}}
>

{products.map(p=>(
<SwiperSlide key={p.id}>

<div className="recCard">

<img src={p.images[0]?.src} alt={p.name}/>

<h4>{p.name}</h4>

<p>₹{Number(p.prices?.price) / 100}</p>

<button onClick={()=>addToCart(p)}>
Add to Cart
</button>

</div>

</SwiperSlide>
))}

</Swiper>

</div>

)

}

export default RecommendedProducts